module.exports = __webpack_public_path__ + "img/UserCircle.8bba3d4f.svg";